import React from "react";

// The css styling for this component is in the ../styles/TextAreaType1.css file

import "./AboutMe.css";
import FadingCarousel from "../FadingCarousel/FadingCarousel";

import MeStuff from "./MeStuff";
import Recommendations from "../Recommendations/Recommendations";
import Connect from "../Connect/Connect"
import Skills from "../Skills/Skills";
// By extending the React.Component class, TextArea inherits functionality from it
class AboutMe extends React.Component 
{ 

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);

	    // Setting the initial state of the TextArea component
	    this.state = 
	    {
	        contents: this.props.value
	    };


    } // End of constructor()
 

	

    
    // The render method returns the JSX that should be rendered
	render() 
	{
	    return (
            <div>
                <div className="container" />
	    	<div className="row">
            <div className="col-md-8 col-sm-10 AboutMeMain">
					
					
					<FadingCarousel componentArray=
                    {
                        [   <MeStuff name="MeStuff"/>,
							<Recommendations name="Recommendations"/>
                            
                        ]
                    
                    }
					labelArray=
                    {
                        [
                            "About Me",
                            "Recommendations",
                            
                        ]
                    }
					
					/>
	    			</div>	
                
		    	
		    	
					<div className="col-md-4 col-sm-12 sam">
                    <div className="row"/>
                    <div className="col-sm-12">
                    <Connect/>
                    </div>
                
                
                

					<div className="row">
                        <div className="col-sm-12">
                        <Skills/>
                        </div>
                    </div>
                    </div>

                    </div>
                    </div>
                
                    

    
		    
             
         		

			

			
		

	    )
	}

}; // End of class AboutMe

export default AboutMe;











// WEBPACK FOOTER //
// ./src/components/AboutMe/AboutMe.js